export default "/_next/static/chunks/fonts/Source Sans Pro BoldIt-1bf66a293f043935040ade597dcd617e.otf";